import React from 'react';
import { useLocation } from 'react-router-dom';
import monthlyPlan from '@/image/hotel/monthly_plan.png';
import { ReactComponent as CheckIcon } from 'src/image/common/check.svg';
import { NavigationButton } from '../common/NavigationButton';

export const MonthlyPlan: React.FC = () => {
  const location = useLocation();
  const langSegment = location.pathname.split('/')[1];
  const language = langSegment === 'en' ? 'en' : 'ja';

  return (
    <div className="container mx-auto">
      {/* SP：タイトル＋画像 */}
      <div className="mb-4">
        <p className="text-center text-lg mb-12">(MONTHLY PLAN)</p>
        <img
          src={monthlyPlan}
          alt="Monthly Plan"
          className="w-full h-auto object-cover md:hidden"
        />
      </div>

      {/* 本体：SPは縦積み、PCは左右並び＆stretch */}
      <div className="text-center md:text-left md:flex md:items-stretch md:space-x-8">
        {/* 左側（PCのみ表示）：画像 */}
        <div className="hidden md:block md:w-1/2">
          <img
            src={monthlyPlan}
            alt="Monthly Plan"
            className="w-full h-auto object-cover"
          />
        </div>

        {/* 右側：flex-col＋justify-betweenで上下分散 */}
        <div className="flex flex-col md:w-1/2 md:justify-between">
          {/* 1. アイコン群：SPで先頭(1)、PCで中段(2) */}
          <div className="order-1 md:order-2 flex justify-center md:justify-start space-x-8 max-md:text-[12px]">
            {/* アイコン1 */}
            <div className="flex flex-col items-center">
              <span className="w-8 h-8 flex items-center justify-center mb-1">
                <CheckIcon />
              </span>
              {language === 'en' ? (
                <>
                  <div>for 30+</div>
                  <p>days</p>
                </>
              ) : (
                <>
                  <div>一ヶ月以上</div>
                  <p>の滞在</p>
                </>
              )}
            </div>
            {/* アイコン2 */}
            <div className="flex flex-col items-center">
              <span className="w-8 h-8 flex items-center justify-center mb-1">
                <CheckIcon />
              </span>
              {language === 'en' ? (
                <p className="text-center">
                  As a home
                  <br />
                  (not as a hotel)
                </p>
              ) : (
                <p className="text-center">
                  家としての使用
                  <br />
                  (賃貸契約)
                </p>
              )}
            </div>
            {/* アイコン3 */}
            <div className="flex flex-col items-center">
              <span className="w-8 h-8 flex items-center justify-center mb-1">
                <CheckIcon />
              </span>
              {language === 'en' ? (
                <>
                  <div>reasonable</div>
                  <p>prices</p>
                </>
              ) : (
                <>
                  <div>リーズナブルな</div>
                  <div>金額で</div>
                </>
              )}
            </div>
          </div>

          {/* 2. テキスト説明：SPで2番目(2)、PCで上端(1) */}
          <div className="order-2 md:order-1 mt-4 md:mt-0 space-y-2">
            {language === 'en' ? (
              <>
                <p className="text-start text-[15px]">
                  Here offers a long-term stay plan that can be used from one
                  month. By signing a lease agreement, you can use HERE at a
                  reasonable price compared to overnight stays. You can use Here
                  for various purposes, such as a place to stay on a long-term
                  business trip, a second living space, or a study space for
                  teleworkers to concentrate on their work.
                </p>
                <p className="text-start">
                  Travel at your own pace and savor a comfortable stay that
                  suits your lifestyle.
                </p>
              </>
            ) : (
              <>
                <p className="text-start text-[15px]">
                  一ヶ月以上の長期滞在は、自分の第二の家として、本当の
                  ネイバーフッド感覚を与えてくれる。月単位で契約ができる
                  マンスリープランは、通常の宿泊よりもリーズナブルな金額で
                  滞在できるので、東京への長期の出張・旅行の拠点として、
                  最善の選択のひとつと言える。
                </p>
                <p className="text-start">
                  快適な暮らしと心地よい時間を、ぜひ体験してください。
                </p>
              </>
            )}
          </div>

          {/* 3. ボタン：SP／PCどちらも左寄せ */}
          <div className="order-3 mt-4 text-left">
            <NavigationButton
              to="/monthly"
              text="Monthly Plan"
              className="border border-black px-4 py-2"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyPlan;
